<template>
	<div class="search-view">
		<input-view v-model="input" :label="$attrs.label" style="width: 100%;" :error="value === null" @keyup="onKeyUp" />
		<div class="options" v-if="presenting">
			<div>
				<div :class="{ option: true, active: optIdx == 0 }" @click.stop="onCreateClick" style="cursor: pointer;">Opret ny</div>
			</div>
			<div v-if="value !== null">
				<div :class="{ option: true, active: optIdx == 1 }" @click.stop="value = null" style="cursor: pointer;">Ryd</div>
			</div>
			<div>
				<div class="separator"></div>
			</div>
			<div v-if="results.length == 0">
				<div class="option no-hover" style="font-style: italic;">Intet fundet</div>
			</div>
			<div v-for="(opt, i) in results" :key="i">
				<div v-if="opt !== null" :class="{ option: true, active: optIdx - (value === null ? 1 : 2) == i }" @click.stop="onOptionClick(opt)">
					<span class="leveled">{{ opt.label }}</span>
				</div>
				<div v-if="opt === null" class="separator"></div>
			</div>
		</div>
	</div>
</template>

<script>
	const delay = 500;

	export default {
		props: {
			value: {
				type: [Object, Number, String],
				default: null
			},
			search: {
				type: Function,
				async default(input) {
					// Nothing found
					console.log('search');
					return [];
				}
			},
			mapName: {
				type: Function,
				async default(item) {
					// Return whole item
					console.log('mapName');
					return item;
				}
			},
			mapId: {
				type: Function,
				async default(item) {
					// Return whole item
					console.log('mapId');
					return item;
				}
			},
			read: {
				type: Function,
				async default(id) {
					// Return blank
					console.log('read');
					return null;
				}
			},
			create: {
				type: Function,
				async default(input) {
					// Do nothing, implement window
					console.log('create');
				}
			}
		},
		data() {
			return {
				prevent:	false,
				optIdx:		null,
				input: 		'',
				timeout: 	null,
				results: 	[],
				presenting: false,
				sync: {
					search:	0,
					read:	0
				}
			};
		},
		watch: {
			input(n, o) {
				if (this.prevent) {
					this.prevent = false;
					return;
				}

				console.log('input change');

				this.clearPresenting();
				this.clearTimeout();

				this.$emit('input', null);

				const self = this;

				this.timeout = setTimeout(() => {
					self.doSearch();
				}, delay);
			},
			value(n, o) {
				this.doRead();
			},
			optIdx(n, o) {
				console.log('optIdx', n);
			}
		},
		computed: {
			_options() {
				return this.results;
			},
			_optCount() {
				return this.results.length + (1) + (this.value === null ? 0 : 1);
			}
		},
		methods: {
			clearTimeout() {
				if (this.timeout !== null) {
					clearTimeout(this.timeout);
					this.timeout = null;
				}
			},
			clearPresenting() {
				this.results = [];
				this.presenting = false;
				this.optIdx = null;
			},
			onOptionClick(opt) {
				this.clearPresenting();
				//this.value = opt.id;
				this.$emit('input', opt.id);
			},
			onCreateClick() {
				this.clearPresenting();
				this.create(this.input);
			},
			onKeyUp(e) {
				if (e.code == 'Enter' && this.optIdx === null) {
					console.log('e', e, e.code);
					this.doSearch();
				}

				if (e.code == 'Enter' && this.optIdx !== null) {
					console.log('e', e, e.code);
					
					if (this.optIdx == 0) {
						console.log('should create click');
						this.onCreateClick();
					} else if (this.optIdx == 1 && this.value !== null) {
						//this.value = null;
						this.$emit('input', null);
					} else {
						this.onOptionClick(this.results[this.optIdx - (this.value === null ? 1 : 2)]);
					}
				}

				if (e.code == 'ArrowDown') {
					if (this.optIdx === null) {
						this.optIdx = 0;
					} else if (this.optIdx + 1 >= this._optCount) {
						this.optIdx = this._optCount - 1;
					} else {
						this.optIdx = this.optIdx + 1;
					}
				}

				if (e.code == 'ArrowUp' && this.optIdx !== null) {
					if (this.optIdx - 1 < 0) {
						this.optIdx = 0;
					} else {
						this.optIdx = this.optIdx - 1;
					}
				}
			},
			async doRead() {
				this.prevent = true;

				if (this.value === null) {
					console.log('NILLED!');
					this.input = '';
					return;
				}

				const t = (new Date()).getTime();
				this.sync.read = t;

				const item = await this.read(this.value);

				if (this.sync.read > t) return;

				this.input = await this.mapName(item);
			},
			async doSearch() {
				if (this.input.length < 3) return;
				this.clearTimeout();

				const t = (new Date()).getTime();
				this.sync.search = t;

				const r = await this.search(this.input);

				if (this.sync.search > t) return;

				var r2 = [];

				for (var i = 0; i < r.length; ++i) {
					const d = await Promise.all([
						this.mapId(r[i]),
						this.mapName(r[i])
					]);

					r2.push({
						id: 	d[0],
						label: 	d[1]
					});
				}

				this.results = r2;
				this.presenting = true;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.search-view {
		position: relative;

		& > .options {
			position: absolute;
			left: 0;
			top: 54px;
			background-color: white;
			min-width: 100%;
			max-height: 350px;
			overflow-y: auto;
			z-index: 10000;

			-webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.15);
			-moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.15);
			box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.15);

			& > div {
				& > .option {
					padding: 10px 20px 10px 15px;
					position: relative;
					cursor: pointer;

					& .buttons {
						position: absolute;
						top: 11px;
						right: 10px;

						& > .button {
							float: right;
							margin-left: 10px;
							fill: rgb(177, 177, 177);

							&.add {
								transform: scale(0.8);
							}
						}
					}

					&:hover, &.active {
						background-color: #F5F5F5;

						&.no-hover {
							background-color: white;
							cursor: default;
						}
					}
				}

				& > .separator {
					height: 1px;
					background-color: #d6d6d6;
					cursor: default;
				}
			}
		}
	}
</style>